<template>
  <div>

    <div class="candidature-body"/>
    <CandidatureHeader></CandidatureHeader>
    <CandidatureSteps :level=3></CandidatureSteps>

    <div class="candidature-group candidature-validation col-md-12">
      <div class="candidature-validation-title">
        Souhaitez-vous valider le dépôt de candidature ?<sup>*</sup>
      </div>
      <div class="candidature-validation-text">
        Votre candidature va être traitée par un centre de formation affecté automatiquement selon votre domicile. Vous pourrez modifier vos informations si nécessaire.<br/><br/>
        <span style="color:orange;"><sup>*</sup>Si vous ne validez pas votre dossier de candidature, celui-ci sera supprimé.</span>
      </div>
    </div>

    <div v-if="this.finishToLoad && this.ifFilesMissing" class="form-group candidature-alert"><b>Attention: il manque un ou plusieurs fichiers importants pour pouvoir étudier votre dossier de candidature en détail. Nous vous invitons donc à compléter votre dossier en y joignant les informations manquantes le plus rapidement possible.</b></div>
    <div v-if="this.finishToLoad && !this.ifFilesMissing" class="form-group">
      <button
          :disabled="isDisabled"
          class="btn btn-primary btn-block"
          @click="validation"
      >
            <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
            ></span>
        Valider
      </button>
    </div>
  </div>
</template>

<script>

import CandidatureHeader from '@/components/Candidature/Header.vue'
import CandidatureSteps from '@/components/Candidature/Steps.vue'
import UserService from "@/services/user.service";
import Toast from "@/_helpers/AlerteHelper";


export default {
  name: "CanditatureParcoursProfessionnel",
  components: {
    CandidatureHeader,
    CandidatureSteps,
    UserService,
  },
  data() {
    return {
      loading: false,
      finishToLoad: false,
      ifFilesMissing: true
    }
  },
  computed: {
    isDisabled: function () {
      return this.loading;
    },
  },
  methods: {
    validation: function () {

      this.loading = true
      let status = this.candidacy.status
      UserService.sendCandidacy().then(
          () => {
            if ("Expiré" === status) {
              Toast(
                  'success',
                  'Demande de prolongation en cours',
                  'top-end',
                  2000)
              UserService.extendCandidacy().then(
                  () => {
                    Toast(
                        'success',
                        'Demande de prolongation acceptée',
                        'top-end',
                        2000)
                    this.$router.push({name: 'dashboard'});
                  }
              )
            } else {
              this.$router.push({name: 'dashboard'});
            }

          })
    },
    checkIfFilesMissing: function (documents) {
      var hasDiploma = false
      var hasCV = false
      var hasCertificate = false
      documents.forEach((doc) => {
        if (doc.typeOfMedia === "DIPLOMA") hasDiploma = true;
        if (doc.typeOfMedia === "CV") hasCV = true;
        if (doc.typeOfMedia === "TRAININGCERTIFICATE") hasCertificate = true;
      });

      return !(hasDiploma && hasCV && hasCertificate);
    }
  },
  mounted() {

    UserService.getCandidacyByUser().then(
        (response) => {
          this.candidacy = response.data;
          this.ifFilesMissing = this.checkIfFilesMissing(response.data.medias);
          this.finishToLoad = true;
        }
    ).catch(
        () => {
          this.$router.push({name: 'dashboard'});
        }
    );

  }
};
</script>
